import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import ClickableDrupalContent from "common/ClickableDrupalContent.js";
import Attachments, { attachmentsPropTypes } from "common/Attachments.js";
import RelatedContent, { relatedContentPropTypes } from "common/RelatedContent.js";
import RelatedDocuments, { relatedDocumentsPropTypes } from "common/RelatedDocuments.js";
import RelatedLinks, { relatedLinksPropTypes } from "common/RelatedLinks.js";
import NodeImage from "common/NodeImage.js";
import Languages from "common/Languages.js";
import { renderUrl } from "common/utils.js";
import SocialShare from "common/SocialShare.js";
import { imagePropTypes } from "common/Image.js";

export default class Page extends PureComponent {
	static propTypes = {
		t: PropTypes.func.isRequired,
		node: PropTypes.shape({
			type: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			alias: PropTypes.string.isRequired,
			language: PropTypes.string.isRequired,
			languages: PropTypes.arrayOf(PropTypes.string).isRequired,
			body: PropTypes.string.isRequired,
			image: imagePropTypes,
			attachments: attachmentsPropTypes,
			relatedContent: relatedContentPropTypes,
			relatedDocuments: relatedDocumentsPropTypes,
			relatedLinks: relatedLinksPropTypes
		})
	};

	render() {
		const { t, node } = this.props;
		return (
			<Fragment>
				<Languages languages={node.languages} language={node.language} alias={node.alias} />
				<h1>{node.title}</h1>
				<NodeImage image={node.image} />
				<ClickableDrupalContent content={node.body} />
				<Attachments t={t} attachments={node.attachments} />
				<RelatedDocuments t={t} relatedDocuments={node.relatedDocuments} />
				<RelatedLinks t={t} relatedLinks={node.relatedLinks} />
				<SocialShare t={t} url={renderUrl(node.alias, node.language)} />
				<RelatedContent t={t} relatedContent={node.relatedContent} />
			</Fragment>
		);
	}
}
